__webpack_require__.p = "https://bmidxbnorwayplprod.netlify.app/";